<template>
  <!-- <h2>楓之谷R儲值流程</h2> -->
  <div class="infoCenter tcCss">
    <h3>一、选择大区</h3>
    <p>
      根据您所在的地区选择对应的游戏大区。请注意：不同大区之间的角色数据是不互通的。
    </p>
    <p>
      例如，您在美洲大区创建的角色，将不会出现在欧洲大区的玩家列表或排行榜中。
    </p>
    <img src="./../../../assets/info/tc/1.png" />

    <h3>二、游戏登录/注册</h3>
    <p>
      登录/注册页面。目前游戏一共支持4种登录方式，分别是快速注册、Facebook登录、Google账号登录，以及邮箱登录。（如果您是已拥有移动端账号的US玩家，请先为您的账号绑定邮箱，再登录WEB端。这样，您就可以在WEB上使用同一个账号角色进行游戏了。）
    </p>
    <img src="./../../../assets/info/tc/2.png" />

    <p>
      快速注册时，选择【注册】，手动输入自定义账号和自定义密码，二次确认密码后点击下方的【注册】按钮，即可完成账号注册并进入游戏。
    </p>
    <img src="./../../../assets/info/tc/3.png" />
    <h3>三、储值中心（最高可享受20%返利！）</h3>
    <p>
      1、PC端进入游戏后，将角色等级提升至17级即可解锁【储值功能】，点击左上方【商城】或者点击【蓝钻】图标，即可进入礼包购买页面。
    </p>
    <img src="./../../../assets/info/tc/3_1.png" />
    <p>2、点击任意礼包拉起储值页面，并选择您的国家和语言：</p>
    <img src="./../../../assets/info/tc/3_2.png" />
    <p>3、选择您使用的付款方式并选择您需要的商品：</p>
    <img src="./../../../assets/info/tc/3_3.png" />
    <p>4、进入二次购买确认界面，核对您的区服、角色信息，确认无误后进行支付：</p>
    <img src="./../../../assets/info/tc/3_4.png" />
    <img src="./../../../assets/info/tc/3_5.png" />
    <p>
      5、支付成功之后即可返回游戏内领取您所购买的彩钻！（彩钻是游戏内的重要货币，可以用来购买任意付费礼包、充值蓝钻等，同时使用彩钻还能增加付费声望！）
    </p>
    <img src="./../../../assets/info/tc/3_6.png" />
    <h3>四、更多页面功能</h3>
    <p>1、下载</p>
    <p>
      玩家点击【安装】后，游戏页面将在独立窗口中打开，同时可固定至桌面任务栏，点击即可快速进入游戏。此外，也可在【开始】界面找到启动图标。
    </p>

    <img src="./../../../assets/info/tc/4.png" />

    <p>2. 官网</p>
    <p>点击【官网】，即可跳转至官网页面，查看最新、最全的游戏信息！</p>
    <img src="./../../../assets/info/tc/5.png" />
    <p>3. 收藏</p>
    <p>
      点击【收藏】后，当前页面将被添加至浏览器收藏夹。打开浏览器后，可直接在收藏夹中启动游戏！
    </p>

    <img src="./../../../assets/info/tc/6.png" />

    <p>4. 客服</p>
    <p>
      点击【客服】按钮进入客服中心，可查看快捷FAQ快速查找解决方案。若快捷问题仍未解决，请前往官方Facebook粉丝专页私信CM反馈。
    </p>
    <p>
      Facebook：<a href="https://www.facebook.com/Global.MapleStoryR"
        >https://www.facebook.com/Global.MapleStoryR</a
      >
    </p>
    <img src="./../../../assets/info/tc/7.png" />
  </div>
</template>

<script>
export default {
  name: "RastarTc",
  data() {
    return {};
  },
  created() {},
};
</script>

<style lang="scss" src="./style.scss" scoped></style>
